module.exports = __webpack_public_path__ + "static/img/6.b61b63f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/2/6.png
// module id = 6Dvj
// module chunks = 1